import useReveal from "../lib/useReveal";
import { Sparkles } from "lucide-react";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/ec5eeaaa-4b23-48dc-b3bc-16242345f9e3/images/98894819447dfdd12af78431e55e7d946ac5fc8b324a8df6a90897539581acb9.png";

export const Hero = () => {
  const ref = useReveal();
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-28 sm:pt-32 lg:pt-40 pb-14 sm:pb-20 lg:pb-32 overflow-hidden grain"
    >
      {/* soft hero texture */}
      <div
        aria-hidden
        className="absolute inset-0 -z-10 opacity-[0.28]"
        style={{
          backgroundImage: `url(${HERO_BG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          maskImage:
            "radial-gradient(ellipse at 70% 30%, black 30%, transparent 75%)",
          WebkitMaskImage:
            "radial-gradient(ellipse at 70% 30%, black 30%, transparent 75%)",
        }}
      />

      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 sm:gap-12 items-end" ref={ref}>
          <div className="reveal lg:col-span-8">
            <div className="flex items-center gap-3 mb-6 sm:mb-8">
              <span className="h-px w-10 sm:w-12 bg-[#C25E3E]" />
              <span className="uppercase text-[10px] sm:text-xs tracking-[0.28em] text-[#C25E3E] font-semibold">
                Holistic Health Sciences
              </span>
            </div>

            <h1
              data-testid="hero-headline"
              className="font-display text-5xl sm:text-6xl lg:text-[7.5rem] leading-[0.95] tracking-tight text-[#1E3A2B]"
            >
              Heal the root,
              <br />
              <span className="italic text-[#C25E3E]">not just</span> the
              symptom.
            </h1>

            <p
              data-testid="hero-subtext"
              className="mt-7 sm:mt-10 max-w-2xl text-base sm:text-lg lg:text-xl leading-relaxed text-[#1E3A2B]/75"
            >
              At Aasa Healthscience &amp; Nutrition, certified doctors,
              nutritionists, physiotherapists and trainers work together to
              reverse metabolic disorders — through food that fits your body,
              movement that fits your life, and goals you can actually measure.
            </p>

            <div className="mt-8 sm:mt-10 flex flex-wrap items-center gap-3 sm:gap-4">
              <a
                href="#consult"
                data-testid="hero-primary-cta"
                className="btn-primary inline-flex items-center gap-2 rounded-full bg-[#C25E3E] text-[#FCFBF7] px-5 py-3 sm:px-7 sm:py-4 text-xs sm:text-sm tracking-wider uppercase"
              >
                Book a consult
                <span aria-hidden>→</span>
              </a>
              <a
                href="#services"
                data-testid="hero-secondary-cta"
                className="inline-flex items-center gap-2 rounded-full border border-[#1E3A2B]/30 px-5 py-3 sm:px-7 sm:py-4 text-xs sm:text-sm tracking-wider uppercase text-[#1E3A2B] hover:bg-[#1E3A2B] hover:text-[#FCFBF7] transition-colors"
              >
                Explore programs
              </a>
            </div>
          </div>

          <div className="reveal lg:col-span-4 lg:pl-8 lg:border-l lg:border-[#D5CEBA]">
            <div className="grid grid-cols-3 lg:grid-cols-1 gap-6 sm:gap-8">
              <Stat number="300+" label="Lives transformed across India" />
              <Stat number="14" label="Clinical conditions addressed" />
              <Stat number="4" label="Disciplines on every plan" />
            </div>
            <div className="mt-8 sm:mt-10 flex items-center gap-3 text-[#1E3A2B]/70">
              <Sparkles className="w-4 h-4 text-[#C25E3E]" />
              <span className="text-[10px] sm:text-xs uppercase tracking-[0.2em]">
                Customised. Measurable. Sustainable.
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Stat = ({ number, label }) => (
  <div data-testid={`hero-stat-${number}`}>
    <div className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#1E3A2B] leading-none">
      {number}
    </div>
    <div className="mt-1.5 sm:mt-2 text-xs sm:text-sm text-[#1E3A2B]/65 max-w-[14rem]">
      {label}
    </div>
  </div>
);

export default Hero;
